import React from 'react';
import GridLoader from "react-spinners/GridLoader";
import { css } from "@emotion/core";
import '../css/Loader.css';


const override = css`
  display: block;
  position:absolute;
  bottom:80px;
  left:-21px;
  border:5px #2279bc ;
  z-index = 40000;
`;

class Loading extends React.Component {
    constructor(props){
        super(props);
        this.state={
            loading: props.loading
        }
    }
    componentDidMount() {
    }
    componentWillReceiveProps(props) {
        this.setState(
            {loading:props.loading})
    }
    render () {
        return (
            <div id={"loader"}>
                <GridLoader
                    css={override}
                    size={8}
                    color={"#db286e"}
                    loading={this.state.loading}
                />
            </div>
        );
    }
}

export default Loading;
